module.exports = __webpack_public_path__ + "img/9788925542737.6b953b9c.jpg";